<template>
  <iRow>
    <iButton size="small" @click="brandAction">
      {{ buttonTitle }}
    </iButton>
  </iRow>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { myFavoriteAdvertiserCollectionStore } from "@/stores/my-favorite-advertiser-collection-store";
export default {
  name: "MyBrandsButton",
  props: {
    advertiserOrgId: {
      type: Number,
      required: true,
    },
    creatorOrgId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState(myFavoriteAdvertiserCollectionStore, ["isLoading", "isLoved"]),
    buttonTitle() {
      return !this.isLoved ? "Add to My Brands" : "Remove from My Brands";
    },
  },
  created() {
    this.isAdvertiserLoved(this.advertiserOrgId);
  },
  methods: {
    ...mapActions(myFavoriteAdvertiserCollectionStore, [
      "addAdvertiserToFavorites",
      "removeAdvertiserFromFavorites",
      "isAdvertiserLoved",
    ]),
    brandAction() {
      if (this.isLoved) {
        this.removeAdvertiserFromFavorites(this.advertiserOrgId);
      } else {
        this.addAdvertiserToFavorites(this.advertiserOrgId);
      }
    },
  },
};
</script>
